import isEmpty from "lodash/isEmpty"
import { clientProfileFields } from "./ClientProfileDataForm"
import { translate, intl } from "./translation"

const validateClientProfileDataForm = (values) => {
    const errors = {}
    const optionalFields = ['bus']

    for (const field of clientProfileFields) {
        if (!values[field] && !optionalFields.includes(field)) {
            errors[field] = translate(intl.requiredField)
        }
    }

    if (!/^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/i.test(values.birthDate)) {
        errors.birthDate = translate(intl.invalidBirthDate)
    }

    function hasDefaultValue(list) {
        for (const item of list) {
            if (item.default) return true // eslint-disable-line curly
        }
        return false
    }

    if (isEmpty(values.emails)) {
        errors.emails = translate(intl.emailsRequired)
    }

    if (values.emails && !hasDefaultValue(values.emails)) {
        errors.emails = translate(intl.requiredDefaultEmail)
    }

    if (isEmpty(values.phoneNumbers)) {
        errors.phoneNumbers = translate(intl.phoneNumbersRequired)
    }

    if (values.phoneNumbers && !hasDefaultValue(values.phoneNumbers)) {
        errors.phoneNumbers = translate(intl.requiredDefaultPhone)
    }

    return errors
}

const validateClientProfileDataFormValue = ({email, number}) => {
    const errors = {}
    if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        errors.email = translate(intl.invalidEmail)
    }
    if (number && !/^\d+$/i.test(number)) {
        errors.number = translate(intl.invalidPhoneNumber)
    }
    return errors
}

export { validateClientProfileDataForm, validateClientProfileDataFormValue }



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/client-profile-form/validation.js